import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9 6.5625V9.5625",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9 11.8125C9.10355 11.8125 9.1875 11.7286 9.1875 11.625C9.1875 11.5214 9.10355 11.4375 9 11.4375C8.89645 11.4375 8.8125 11.5214 8.8125 11.625C8.8125 11.7286 8.89645 11.8125 9 11.8125Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9 11.6252V11.6177",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.09776 12.1709L7.71074 2.73087C8.29216 1.75302 9.70792 1.75302 10.2893 2.73087L15.9023 12.1709C16.4969 13.1708 15.7763 14.4375 14.613 14.4375H3.38706C2.22379 14.4375 1.50324 13.1708 2.09776 12.1709Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }